import BuryingPoint, {
  BuryingPointSource,
  BuryingPointType,
} from '@ys/crm-common/dist/utils/BuryingPoint'

import store from '@/store'

export default function buryingPointRouteGuard(router) {
  let loginBuryingPoint

  router.beforeEach(async (_to, _from, next) => {
    if (!store.getters.accessToken) {
      if (loginBuryingPoint) {
        loginBuryingPoint.stop()
      }
      next()
      return
    }
    if (!loginBuryingPoint) {
      loginBuryingPoint = new BuryingPoint({
        type: BuryingPointType.Login,
        source: BuryingPointSource.Pc,
      })
    }
    next()
  })
}
